<ng-container *ngIf="selected">
  <button *ngIf="canChange; else staticPill" type="button" class="tcc-pill"
    [class.tcc-pill--field]="size === 'field'" [matMenuTriggerFor]="companiesMenu"
    (menuClosed)="searchControl.setValue('')" aria-label="Cambiar empresa de transporte" aria-haspopup="listbox">
    <ng-container *ngTemplateOutlet="pillContent"></ng-container>
    <i class="fas fa-exchange-alt tcc-pill__swap" aria-hidden="true"></i>
  </button>

  <ng-template #staticPill>
    <span class="tcc-pill tcc-pill--static" [class.tcc-pill--field]="size === 'field'">
      <ng-container *ngTemplateOutlet="pillContent"></ng-container>
    </span>
  </ng-template>

  <ng-template #pillContent>
    <span class="tcc-pill__label">Empresa:</span>
    <span class="tcc-pill__name">{{ selected.name }}</span>
  </ng-template>

  <mat-menu #companiesMenu="matMenu" class="transport-company-context-menu" xPosition="before">
    <div class="tcc-menu__title">Cambiar empresa de transporte</div>
    <div *ngIf="showSearch" class="tcc-menu__search" (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()">
      <input type="text" [formControl]="searchControl" placeholder="Buscar empresa…" autocomplete="off">
    </div>
    <button mat-menu-item type="button" *ngFor="let company of filteredCompanies" (click)="select(company)"
      [class.tcc-menu__item--selected]="company.companyId === selected.companyId">
      <span class="tcc-avatar tcc-avatar--small">{{ initials(company.name) }}</span>
      <span class="tcc-menu__name">{{ company.name }}</span>
      <i *ngIf="company.companyId === selected.companyId" class="fas fa-check tcc-menu__check" aria-hidden="true"></i>
    </button>
    <div *ngIf="!filteredCompanies.length" class="tcc-menu__empty">Ninguna empresa coincide con la búsqueda.</div>
  </mat-menu>
</ng-container>
